<template>
    <va-edit-layout>
        <CouponPaymentEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></CouponPaymentEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
